/** @deprecated do not reference this directly; use the theme provided values */
export const primaryPalette = {
  25: '#fafafa',
  50: '#f4f8fe',
  100: '#ebf1fe',
  200: '#c4d4fd',
  300: '#9db8fb',
  400: '#628df8',
  500: '#2a64f6',
  600: '#0943d7',
  700: '#07319d',
  800: '#052576',
  900: '#03194e',
  950: '#020f26',
} as const;

/** @deprecated do not reference this directly; use the theme provided values */
export const errorPalette = {
  25: '#fcf8f8',
  50: '#faf1f1',
  100: '#fee4e2',
  200: '#fecdca',
  300: '#fda29b',
  400: '#f97066',
  500: '#f04438',
  600: '#d92d20',
  700: '#b42318',
  800: '#912018',
  900: '#7a271a',
  950: '#1A0001',
} as const;

/** @deprecated do not reference this directly; use the theme provided values */
export const neutralsPalette = {
  25: '#fdfdfe',
  50: '#fcfcfd',
  100: '#fbfbfc',
  200: '#f5f6f8',
  300: '#eff2f3',
  400: '#e5e9ec',
  500: '#dbe0e4',
  600: '#6b7881',
  700: '#4a5b67',
  800: '#36424a',
  900: '#242d35',
  950: '#161c22',
} as const;

/** @deprecated do not reference this directly; use the theme provided values */
export const greenPalette = {
  25: '#f4fbf8',
  50: '#edf9f5',
  100: '#e6f7f2',
  200: '#ceefe3',
  300: '#83d6bc',
  400: '#45c49f',
  500: '#07b282',
  600: '#078c63',
  700: '#04543b',
  800: '#04422e',
  900: '#033021',
  950: '#021c14',
} as const;

/** @deprecated do not reference this directly; use the theme provided values */
export const purplePalette = {
  25: '#faf6ff',
  50: '#f7f0ff',
  100: '#f3ebff',
  200: '#dbc2ff',
  300: '#c399ff',
  400: '#ac70ff',
  500: '#934bff',
  600: '#6200f5',
  700: '#4100a3',
  800: '#290066',
  900: '#18003d',
  950: '#0e0022',
} as const;

/** @deprecated do not reference this directly; use the theme provided values */
export const orangePalette = {
  25: '#fefaf6',
  50: '#fcf8f1',
  100: '#fcf5ec',
  200: '#faebd9',
  300: '#efcda0',
  400: '#f1af50',
  500: '#f39000',
  600: '#b26500',
  700: '#8a4e00',
  800: '#623700',
  900: '#3a2000',
  950: '#261400',
} as const;

/** @deprecated do not reference this directly; use the theme provided values */
export const warningPalette = orangePalette;

/** @deprecated do not reference this directly; use the theme provided values */
export const infoPalette = primaryPalette;

export const successPalette = greenPalette;
